import { render, staticRenderFns } from "./addBtn.vue?vue&type=template&id=5723d52e&scoped=true"
import script from "./addBtn.vue?vue&type=script&lang=js"
export * from "./addBtn.vue?vue&type=script&lang=js"
import style0 from "./addBtn.vue?vue&type=style&index=0&id=5723d52e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5723d52e",
  null
  
)

export default component.exports